<template>
  <div class="data-table" >
    <filters-display
      v-if="!editing"
      ref="filter"
      :filter="filter"
      :canEdit="canEdit || false"
      :useGlobalFilters="useGlobalFilters"
      @change="updateFilters" />
    <div class="wrapper" >
      <el-table :data="data" :border="true" >
        <el-table-column
          v-for="column in viewsConfig.columns"
          :key="column.uniqueName"
          :prop="column.name"
          :label="column.name"
          :sortable="true" />
      </el-table>
    </div>
  </div>
</template>

<script>
import {api} from 'macarons'
import Editable from './Editable'
import ViewsWidgetEdit from './ViewsWidgetEdit'
import FiltersDisplay from './components/FiltersDisplay'
import globalFilterAware from './mixins/globalFilterAware'

export default {
  extends: Editable,
  mixins: [
    globalFilterAware
  ],
  components: {
    FiltersDisplay
  },
  props: {
    widget: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      editable: ViewsWidgetEdit,
      viewsConfig: {
      },
      data: []
    }
  },
  mounted () {
    this.load()
  },
  watch: {
    viewsConfig: {
      handler () {
        this.updateData()
      },
      deep: true
    },
    
  },
  methods: {
    save () {
      this.editing = false
      return api.post('view/widget/' + this.widget.id, {
        title: null,
        view: this.viewsConfig.view.uniqueName,
        columns: this.viewsConfig.columns.map(c => c.uniqueName),
        filters: this.serializeFilter()
      }).then(() => {
        this.cancel()
      })
    },
    load () {
      Promise.all([
        api.get('view/widget/' + this.widget.id).then(({data}) => data),
        this.$store.dispatch('customGraph/loadViews')
      ]).then(responses => {
        this.id = responses[0].id
        const view = responses[1].find(view => view.uniqueName === responses[0].view) || null
        this.viewsConfig.view = view
        this.viewsConfig.columns = (view ? view.columns : []).filter(column => {
          return responses[0].columns.findIndex(c => c === column.uniqueName) !== -1
        })
        Promise.all([
          this.loadState(responses[0].id, 'view'),
          this.loadFilters(responses[0].filters)
        ]).then(responses => {
          if (responses[0] !== null) {
            this.setFilterState(responses[0].filters)
          } else {
            this.setFilters(true)
          }
        })
      })
    },
    buildQuery () {
      const filters = {}
      const data = this.useGlobalFilters ? this.globalFilters : [].concat(...this.filter.map(
        f => (typeof f.active === 'undefined' ? f.defaultValues : f.active).map(a => a.uniqueName)
      ))
      data.forEach(f => {
        filters[f] = f
      })
      const query = {
        route: 'data/executeView',
        view: this.viewsConfig.view.uniqueName,
        columns: this.viewsConfig.columns.map(c => c.uniqueName).join(','),
        filters: Object.keys(filters)
      }
      if (this.$store.state.board.data && this.$store.state.board.data.universe) {
        query.universe = this.$store.state.board.data.universe
      }
      return query
    },
    updateData () {      
      if (this.viewsConfig.view && this.viewsConfig.columns && this.viewsConfig.columns.length) {
        this.$store.dispatch('customGraph/DSNQuery', this.buildQuery()).then(data => {
          this.data.splice(0, this.data.length, ...data.data)
        })
      } else {
        this.data.splice(0, this.data.length)
      }
    },
    saveState: function () {
      if (this.id !== null && this.ready) {
        api.post('view/' + this.id + '/state', {
          state: JSON.stringify({
            filters: this.filter
          })
        })
      }
    }
  }
}
</script>

<style scoped>
.data-table {
    overflow: auto;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px;
}
.wrapper {
    position: relative;
}
.data-table >>> table {
    border: collapse;
    margin-bottom: 2px;
}
.data-table >>> tr.selected td {
    border-top: 1px solid red;
    border-bottom: 1px solid red;
    border-right: 1px solid red;
    position: relative;
}
.data-table >>> tr.selected td::before {
    content: "";
    width: 1px;
    height: 100%;
    display: block;
    background-color: white;
    position: absolute;
    z-index: 1;
    top: 0;
    left: -1px;
}
.data-table >>> tr.selected td:first-child {
    border-left: 1px solid red;
}
.data-table >>> tr.selected td:first-child::before {
    display: none;
}
</style>




// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/ViewsWidget.vue